<template>
    <div class="flex h-full flex-col gap-2 rounded-md border border-border/40 p-3 shadow-xs">
        <ReviewStars :review-score="review.rating ?? 0" size="sm" show-rating />

        <p class="line-clamp-3 text-sm whitespace-pre-line" v-safe-html="displayText" />

        <button
            type="button"
            class="cursor-pointer self-start text-sm text-black underline transition outline-none hover:opacity-80"
            @click="$emit('on-read-full-review', review)"
        >
            {{ t('general.reviews.read_full_review') }}
        </button>

        <div class="mt-auto flex items-center justify-between text-sm text-slate-500">
            <span>{{ review.user?.short_name ?? review.author }}</span>
            <span>{{ formattedCreatedAt }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import ReviewStars from '@/components/reviews/ReviewStars.vue';
import { useDateFormatter } from '@/composables/useDateFormatter';
import { LipscoreProductReviewObject } from '@/types/generated';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

type ProductReviewHighlightCardProps = {
    review: LipscoreProductReviewObject;
};

const props = defineProps<ProductReviewHighlightCardProps>();

defineEmits<{
    (e: 'on-read-full-review', review: LipscoreProductReviewObject): void;
}>();

const { t } = useI18n();
const { formatDateShort } = useDateFormatter();

const formattedCreatedAt = computed(() => formatDateShort(props.review.created_at));

const displayText = computed(() => {
    const hasTranslation = props.review.translated_text !== null && props.review.translated_text !== props.review.text;
    return hasTranslation ? props.review.translated_text : props.review.text;
});
</script>
